// extracted by css-extract-rspack-plugin
export default {"root":"AddColumnButton-module__root___neGde","sticky":"AddColumnButton-module__sticky___HEqlC","button":"AddColumnButton-module__button___CYwhs"};